// extracted by mini-css-extract-plugin
export default {"changeLink":"EL-z","disabled":"FL-z","inline":"GL-z"};